import * as angular from 'angular';
import {IController, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {BillingAccount} from "../../../billing-accounts/models/billing-account.model";
import {BillingContact} from "../../../billing-accounts/models/billing-contact.model";
import {SplitService} from "../../../commons/services/split-service.service";

export class OrderPrintBillOfLading implements IController {
  orders: any;
  billingAccount: BillingAccount;

  public logoUrl: any;
  public siteAddress: any;
  public siteName: string;
  private billingContact: BillingContact;

  /* @ngInject */
  constructor(private splitService: SplitService, private $window: IWindowService, private $timeout: ITimeoutService) {
  }

  $onInit() {
    this.logoUrl = this.splitService.getSiteLogoUrl();
    this.siteAddress = this.splitService.getSiteAddress();
    this.siteName = this.splitService.getSiteName();
    this.billingContact = this.billingAccount.billingContacts.find(innerBillingContact => {
      return innerBillingContact.primary == true;
    });
  }

  //sends it to printer
  $postLink() {
    if (this.orders.length == 1) {
      if (this.orders[0].externalId) {
        document.title = this.orders[0].externalId;
      } else if (_.get(this.orders[0],'itemLines[0].barcode')) {
        document.title = this.orders[0].itemLines[0].barcode;
      } else if(_.get(this.orders[0],'id')) {
        document.title = this.orders[0].id;
      }
    }

    this.$timeout(1000).then(() => {
      this.$window.print();
      this.$window.close();
    })
  };

}

angular
  .module('bringoz.admin.oms')
  .component('orderPrintBillOfLading', {
    bindings: {
      orders: '<',
      billingAccount: '<'
    },
    template: require('./order-print-bill-of-lading.html').default,
    controller: OrderPrintBillOfLading
  });
